export default __webpack_public_path__ + "static/media/contact-us-wave-medium.cdbc6689.svg";